import React, { useState, useEffect } from "react";
import userService from "../services/user";
import collaborationService from "../services/collaboration";
import projectService from "../services/project";
import session from "../services/session";

import { Redirect } from "react-router-dom";
import {
  swalError,
  swalInfo,
  swalLoading,
  swalShare,
  swalSuccess,
} from "../utils/swal";
import { validateEmail } from "../utils/utils";
import Swal from "sweetalert2";
import Rodal from "rodal";
import "rodal/lib/rodal.css";
import Collaborators from "./Collaborators";
import LinkIcon from "@material-ui/icons/Link";
import PersonAddIcon from "@material-ui/icons/PersonAdd";

export default function Collaborate(props) {
  const [list, setList] = useState("");
  const [count, setCount] = useState(1);
  const [copied, setCopied] = useState(false);
  const [isPublic, setIsPublic] = useState(props.project.isPublic || false);

  const handleVisibilityChange = async (e) => {
    const newValue = e.target.value === "public";
    setIsPublic(newValue);
    await projectService.setVisibility(props.projectId, newValue);
  };

  const styles = {
    background: "#111114",
    width: "560px",
    maxWidth: "92vw",
    height: "auto",
    maxHeight: "80vh",
    overflowY: "auto",
    top: "50%",
    transform: "translateY(-50%)",
    textAlign: "left",
    padding: "0",
    color: "white",
    borderRadius: "16px",
    border: "1px solid rgba(255,255,255,0.08)",
    boxShadow: "0 24px 80px rgba(0,0,0,0.6)",
  };

  const shareUrl = `https://app.filmboard.io/n/${props.projectId}`;

  const handleCopyLink = () => {
    navigator.clipboard.writeText(shareUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }).catch(() => {
      swalShare(shareUrl);
    });
  };

  const handleDone = async (e) => {
    e.preventDefault();

    if (!props.projectId) return;

    const accessType = document.getElementById("ddlAccessType").value;
    const validEmails = [];
    list.split(",").forEach((email) => {
      email = email.trim();
      if (validateEmail(email)) validEmails.push(email);
    });

    if (validEmails.length === 0) {
      swalInfo(`No valid emails found.`);
      return;
    }

    swalLoading();
    await collaborationService
      .addMany(validEmails, accessType, props.projectId)
      .then((result) => {
        if (result.error) {
          swalError(result.error);
          Swal.close();
          return;
        }

        Swal.close();
        if (result.data.count == 1) {
          swalSuccess(`Added ${result.data.count} user`);
        } else {
          swalSuccess(`Added ${result.data.count} users`);
        }
        setCount(count + 1);
        setList(``);
      });
  };

  return (
    <Rodal
      visible={true}
      onClose={() => props.onClose()}
      closeOnEsc={true}
      closeMaskOnClick={true}
      customStyles={styles}
    >
      <div className="share-modal">
        <div className="share-modal-header">
          <h3 className="share-modal-title">Share Project</h3>
        </div>

        <div className="share-modal-section">
          <div className="share-invite-row">
            <textarea
              className="share-email-input"
              rows={1}
              placeholder="Add emails, separated by commas"
              value={list}
              onChange={(e) => setList(e.target.value)}
            />
            <select className="share-access-select" id="ddlAccessType">
              <option value={1}>Can view</option>
              <option value={2}>Can edit</option>
            </select>
            <button className="share-invite-btn" onClick={handleDone}>
              <PersonAddIcon style={{ fontSize: "18px" }} />
              Invite
            </button>
          </div>
        </div>

        <div className="share-modal-divider"></div>

        <div className="share-modal-section">
          <div className="share-link-row">
            <div className="share-link-box">
              <LinkIcon style={{ fontSize: "18px", color: "#888" }} />
              <span className="share-link-text">{shareUrl}</span>
            </div>
            <button
              className={`share-copy-btn ${copied ? "share-copy-btn-copied" : ""}`}
              onClick={handleCopyLink}
            >
              {copied ? "Copied" : "Copy link"}
            </button>
          </div>
        </div>

        <div className="share-modal-divider"></div>

        <div className="share-modal-section share-modal-section-collab">
          <Collaborators
            reload={count}
            showDeleteButton={
              session.get("user") &&
              session.get("user")._id === props.project.userId._id
            }
          />
        </div>

        <div className="share-modal-divider"></div>

        <div className="share-modal-section">
          <div className="share-community-row">
            <div className="share-community-info">
              <span className="share-community-label">Share with Community</span>
              <span className="share-community-desc">
                {isPublic
                  ? "This project is visible on the community"
                  : "This project is hidden from the community"}
              </span>
            </div>
            <select
              className="share-community-select"
              value={isPublic ? "public" : "private"}
              onChange={handleVisibilityChange}
            >
              <option value="private">Private</option>
              <option value="public">Public</option>
            </select>
          </div>
        </div>
      </div>
    </Rodal>
  );
}
